<template>
  <div v-if="loaded" class="deliver-detail-page">
    <div v-if="waybillNoList.length" class="expand-tab">
      <van-tabs
        v-model="waybillNo"
        color="#15bb5c"
        title-active-color="#15bb5c"
        title-inactive-color="#262626"
        line-width="20px"
        sticky
        @change="handleChangeTab"
      >
        <van-tab
          v-for="item in waybillNoList"
          :key="item.waybillNo"
          :title="item.titleName"
          :name="item.waybillNo"
        >
        </van-tab>
      </van-tabs>
    </div>
    <div v-if="imgSrc" class="content">
      <img :src="imgSrc" @click="previewImg" />
    </div>
    <empty
      v-if="!imgSrc"
      :desc="'暂无配送单'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
    <div v-if="imgSrc" class="bar">
      <div
        v-if="browerInfo.isMallApp || browerInfo.isMiniProgram"
        class="button share"
        :class="{
          ...themeAppColorClass
        }"
        @click="goShare"
      >
        <span class="wxshare">发送给店员</span>
      </div>
      <div
        v-if="canSavePic"
        class="button save"
        :class="{
          ...themeAppColorClass
        }"
        @click="savePicture"
      >
        <span>保存到相册</span>
      </div>
    </div>
    <div
      v-if="showShareMask"
      class="share-mask"
      @click="handleShare"
      @touchmove.prevent
    >
      <div class="share-notice">
        <span>按右上角更多按钮分享给微信好友</span>
        <i class="mcicon-chexiao"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { platform, miniProgramEnv } from '@/defines/environment'
import Url from '@mc/mc-utils/js/url/url'
import { NativeEvent, Bridge } from '@mc/mc-jsbridge'
import wechatMessageIcon from '@/images/delivery_order/wechat_message_icon.png'
import { mpsCombination } from '@/utils/native_interactions/mps_combination'
import { navBar } from '@/utils/native_interactions/native_bar'
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
import { companyId } from '@/defines/user'
import { DEPLOY_ENV } from '@/defines/env'
import { DialogAlert } from '@/utils/dialog.js'
import themeMixin from '@/common/mixins/theme'

export default {
  name: 'DeliverOrderDetail',
  components: { Empty },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = '配送单'
      navBar.setTitle({
        text: title
      })
      document.title = title
      vm.getQuerData()
      vm.getData()
      // 设置白色状态栏
      vm.$bridge.setLightStatusBar()
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.hevueImgPreview) {
      this.hevueImgPreview.close()
    }
    next()
  },
  data() {
    return {
      browerInfo: window.matrix,
      showShareMask: false,
      imgSrc: '',
      shareUrl: '',
      waybillNoList: [],
      orderId: '',
      waybillNo: '',
      companyId: '',
      loaded: false,
      hevueImgPreview: null,
      selected_company_id: ''
    }
  },
  computed: {
    canSavePic() {
      return this.browerInfo.isMallApp || this.browerInfo.isMallKeyCustomerApp
    }
  },
  methods: {
    previewImg() {
      this.hevueImgPreview = this.$hevueImgPreview(this.imgSrc)
    },
    handleChangeTab(waybillNo) {
      this.waybillNo = waybillNo
      this.getData()
    },
    goBack() {
      this.$back()
    },
    getQuerData() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

      this.orderId = query.order_id || hashQuery.order_id || ''
      this.waybillNo = query.waybill_no || hashQuery.waybill_no || ''
      this.selected_company_id =
        query.selected_company_id || hashQuery.selected_company_id || ''
      this.companyId = query.companyId || hashQuery.companyId || companyId || ''
      this.useWayBill = query.useWayBill || hashQuery.useWayBill || ''
    },
    async getData() {
      const parmas = {
        companyId: this.companyId,
        selected_company_id: this.selected_company_id
      }
      // 后端 可能不在使用
      let serviceApi = API.delivery.getDeliveryVoucher
      if (this.orderId && !this.useWayBill) {
        parmas.orderId = this.orderId
        serviceApi = API.delivery.getDeliveryDetail
      }
      if (this.waybillNo) {
        parmas.waybillNo = this.waybillNo
      }
      if (this.browerInfo.isMallKeyCustomerApp) {
        parmas.channel = 1
        parmas.platform = 1
        parmas.from_mall = 'big_mall'
      }
      try {
        const resData = await serviceApi(parmas)
        this.shareUrl = resData.shareUrl || ''
        this.imgSrc = resData.imageBase64 || ''
        if (!this.waybillNo && this.waybillNoList.length > 0) {
          this.waybillNo = this.waybillNoList[0].waybillNo
        }
        this.loaded = true
        // 请求后设置微信分享信息
        this.setCmsWxShareInfo()
      } catch (e) {
        this.loaded = true
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          this.$toast(msg)
        }
      }
    },
    goShare() {
      this.$track(this.$trackMap.deliverOrderDetail.shareDetail)
      if (platform === 'weixin') {
        this.showShareMask = true
        return
      }

      const { title, desc, imgUrl, path, link } = this.shareInfo()

      // 分享小程序卡片
      const hasNativeMethod = Bridge.hasNativeMethod('wx.shareMiniProgram')
      if (hasNativeMethod) {
        const shareMiniProgram = {
          imageUrl: imgUrl,
          title,
          description: desc,
          userName: 'gh_a4b9cd2d059e',
          path,
          webpageUrl: link,
          miniprogramType: DEPLOY_ENV === 'online' ? 0 : 2 /// Int (0 是正式版本、1是Test、2是Preview)小程序的类型，默认正式版
        }
        Bridge.call('wx.shareMiniProgram', shareMiniProgram, res => {
          if (res.ret) {
            DialogAlert('分享成功')
          } else {
            DialogAlert('分享失败')
          }
        })
        return
      }

      // 调用app自己的分享

      const eventId = NativeEvent.on('onShareResult', res => {
        if (res.ret) {
          DialogAlert('分享成功')
        } else {
          DialogAlert('分享失败')
        }
      })
      const shareInfo = this.shareInfo()
      Bridge.openShareTool({
        pic: shareInfo.imgUrl,
        url: shareInfo.link,
        title: shareInfo.title,
        detail: shareInfo.desc
      })
        .then(() => {
          // 移除事件监听
          NativeEvent.remove('onShareResult', eventId)
        })
        .catch(error => {
          console.log(error)
        })
    },

    shareInfo() {
      const url =
        location.origin +
        '/marketing/#/deliver_order_detail?order_id=' +
        this.orderId +
        '&waybill_no=' +
        this.waybillNo
      const shareUrl = this.shareUrl ? this.shareUrl : url
      return {
        title: '我的电子配送单', // 分享标题
        desc: '请点击查看门店的电子电子配送单', // 分享描述
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: wechatMessageIcon, // 分享图标
        path: 'pages/common/webView/index?url=' + encodeURIComponent(shareUrl)
      }
    },
    setCmsWxShareInfo() {
      const shareInfo = this.shareInfo()
      if (platform === 'weixin') {
        if (miniProgramEnv.isMiniProgram) {
          mpsCombination.postMessage({
            data: {
              type: 'shareMessage',
              data: {
                title: shareInfo.title,
                imageUrl: shareInfo.imgUrl
              }
            }
          })
        }
        if (window.wx) {
          window.wx.ready(() => {
            // 需在用户可能点击分享按钮前就先调用
            if (window.wx.updateAppMessageShareData) {
              window.wx.updateAppMessageShareData(shareInfo)
            }
            if (window.wx.updateTimelineShareData) {
              window.wx.updateTimelineShareData(shareInfo)
            }
          })
        }
      }
    },
    // 保存图片
    savePicture() {
      // 保存图片
      this.$track(this.$trackMap.deliverOrderDetail.saveImage)
      const hasNativeMethod = Bridge.hasNativeMethod('savePictureToAlbum')
      if (hasNativeMethod) {
        Bridge.call('savePictureToAlbum', { dataURL: this.imgSrc }, res => {
          if (res.ret) {
            DialogAlert('下载成功')
          } else {
            DialogAlert('下载失败')
          }
        })
      } else {
        DialogAlert('请下载最新版本APP进行图片保存')
      }
    },
    handleShare() {
      this.showShareMask = false
    }
  }
}
</script>

<style lang="scss" scoped>
.deliver-detail-page {
  display: flex;

  position: relative;

  height: 100vh;

  background-color: #fff;

  flex-direction: column;
}
.content {
  height: 0;

  flex: auto;

  overflow-y: auto;
  img {
    width: 100%;
    height: auto;
  }
}
.bar {
  display: flex;

  position: absolute;
  bottom: 0;
  left: 0;

  width: 100%;
  height: 1.08rem;

  background-color: #fff;

  justify-content: flex-end;
  align-items: center;

  box-shadow: 0 1px 8px 4px rgba(100, 100, 100, 0.2);

  flex-flow: row nowrap;

  box-sizing: content-box;

  @include iphonex-padding-bottom(0px);

  .button {
    display: flex;

    margin-right: 0.2rem;

    border-radius: 0.46rem;

    flex: none;
    justify-content: center;
    align-items: center;

    flex-flow: row nowrap;

    span {
      font-size: 0.32rem;
      color: #fff;
    }

    &.save {
      width: 2.04rem;
      height: 0.76rem;

      background-color: #0daf52;
    }

    &.share {
      width: 2.38rem;
      height: 0.76rem;

      background-color: #ffffff;
      border: 1px solid #0daf52;
      .wxshare {
        color: #0daf52;
        &:before {
          display: inline-block;

          width: 0.3rem /* 15/50 */;
          height: 0.24rem /* 12/50 */;
          margin-top: 0.04rem;
          margin-right: 0.08rem /* 4/50 */;

          background-image: url('~@/images/delivery_order/wechat.png');
          background-size: cover;

          flex: none;

          vertical-align: text-top;

          content: '';
        }
      }
    }
    &.small {
      &.save {
        background-color: $theme-main_small;
      }
      &.share {
        border-color: $theme-main_small;
        .wxshare {
          color: $theme-main_small;
        }
      }
    }
  }
}
.share-mask {
  display: flex;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;

  background-color: rgba(0, 0, 0, 0.6);

  flex-direction: column;
  align-items: center;

  .share-notice {
    display: flex;

    width: 5.9rem /* 295/50 */;
    height: 0.7rem /* 35/50 */;
    margin-top: 0.4rem /* 20/50 */;

    background: #ffffff;
    border-radius: 0.35rem /* 17.5/50 */;

    flex: row no-wrap;
    justify-content: center;
    align-items: center;

    font-size: 0.32rem /* 16/50 */;
    line-height: 0.36rem /* 18/50 */;
    color: #0daf52;
  }
}
.expand-tab {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;

  border-bottom: 1px solid #f5f5f5;

  line-height: 20px;
}
</style>
